import { render } from "./HeroiconsSolidAdjustments.vue?vue&type=template&id=6b7a790d"
const script = {}

import exportComponent from "/srv/www/network4web/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidAdjustments.vue"]])

export default __exports__